import { FC } from "react";
import { useTranslation } from "react-i18next";

import { TruncatedText } from "@/components/_molecules/truncated-text/truncated-text";
import { cn } from "@/lib/cn";

import { PriorityIcon } from "./priority-icon";
interface PriorityViewEmptyProps {
  logoOnly?: boolean;
  canTruncateLabel?: boolean;
  className?: string;
}

export const PriorityViewEmpty: FC<PriorityViewEmptyProps> = ({ canTruncateLabel = false, ...props }) => {
  const { t } = useTranslation("common");
  return (
    <div className={cn(["flex flex-row items-center gap-2", canTruncateLabel && "min-w-0"])}>
      <PriorityIcon className={cn(["h-4 w-4 shrink-0", props.className])} />
      {!props.logoOnly && <TruncatedText text={t("notAssigned")} canTruncate={canTruncateLabel} />}
    </div>
  );
};
